import React from "react";
export default function Nav({ children }) {
  return (
    <div className="siteWrapper">
      <header className="siteHeader">
        <a href="/" className="siteHeader-logoLink">
          <img
            src={require("./foundationlogo.png")}
            alt="HANYC Foundation"
            className="siteHeader-logo"
          />
        </a>
      </header>
      <div className="app">{children}</div>
    </div>
  );
}
